export default __webpack_public_path__ + "static/sectorlabs-white-41da0263534a08874ea43e4aded3ec75.png";